const state = {
  mediaPlaying: false,
  runTopMedia: false,
  runVideo: false,
  videoPlayTick: 0,
  viewMap: false
};

// Suggest use getters instead of state
const getters = {
  getMediaPlaying (state) {
    return state.mediaPlaying;
  },
  getRunTopMedia (state) {
    return state.runTopMedia;
  },
  getRunVideo (state) {
    return state.runVideo;
  },
  getVideoPlayTick (state) {
    return state.videoPlayTick;
  },
  getViewMap (state) {
    return state.viewMap;
  }
};

const mutations = {
  setMediaPlaying (state, value) {
    state.mediaPlaying = value;
  },
  setRunTopMedia (state) {
    state.runTopMedia = true;
  },
  setRunVideo (state) {
    state.runVideo = true;
  },
  incrementVideoPlayTick (state) {
    state.videoPlayTick += 1;
  },
  setViewMap (state) {
    state.viewMap = true;
  }
};

const actions = {
  notifyMediaPlaying ({commit}, value) {
    commit('setMediaPlaying', value);
  },
  runTopMedia ({commit}) {
    commit('setRunTopMedia');
  },
  runVideo ({commit}) {
    commit('setRunVideo');
  },
  notifyVideoPlay ({commit}) {
    commit('incrementVideoPlayTick');
  },
  runViewMap ({commit}) {
    commit('setViewMap');
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
